import Reveal from "@/components/base/Reveal";
import SectionHead from "@/components/base/SectionHead";
import { mentorMoments } from "@/mocks/dailyContest";

export default function Mentor() {
  return (
    <section id="mentor" className="border-b border-background-300/70 bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <SectionHead
              eyebrow="导师点评 · 争议现场"
              title="一句点评，能炸出多少瓜"
              desc="从饭拍原声流传到正片删改、导师互怼，我们把每一场点评争议的来龙去脉与双方论据都摊开来讲。"
            />
            <span className="chip shrink-0 bg-secondary-200 text-secondary-800">
              <i className="ri-flashlight-fill mr-1 text-secondary-600" aria-hidden="true" />
              本周累计争议值 253
            </span>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {mentorMoments.map((m, i) => (
            <Reveal key={m.id} delay={i * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-50 transition-colors hover:border-secondary-400">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={m.img}
                    alt={`${m.mentor} 导师点评争议现场配图`}
                    title={`每日大赛网 · 导师点评 · ${m.mentor}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="chip absolute left-3 top-3 bg-secondary-700 text-background-50">{m.stance}</span>
                  <span className="chip absolute right-3 top-3 bg-foreground-950/80 text-background-100">
                    {m.score}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <div className="flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-600 text-sm font-black text-background-50">
                      {m.mentor.slice(0, 1)}
                    </span>
                    <span className="text-sm font-bold text-foreground-900">{m.mentor}</span>
                  </div>
                  <h3 className="mt-3 font-serif text-[16px] font-bold leading-6 text-foreground-950">
                    {m.title}
                  </h3>
                  <p className="mt-2 flex-1 text-[13px] leading-6 text-foreground-600">{m.lead || m.title}</p>
                  <blockquote className="mt-3 rounded-md border-l-2 border-accent-400 bg-accent-50 px-3 py-2.5 text-[13px] italic leading-6 text-accent-800">
                    {m.quote}
                  </blockquote>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={140}>
          <p className="mt-6 flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-checkbox-circle-line text-secondary-600" aria-hidden="true" />
            引语为饭拍或公开片段整理，争议值为站内讨论热度综合，仅供横向参考。
          </p>
        </Reveal>
      </div>
    </section>
  );
}